export default __webpack_public_path__ + "static/media/HauntedDecoderBanner.59cb1836.png";